import StagedCandidateModel from "../../models/cvupload/StagedCandidateModel";

import {
    getStagedCandidate,
    getDuplicates
} from "../../apis/sthree.consultant.api";

export default {
    state: {
        allowedFileTypes: process.env.VUE_APP_CV_FILE_TYPES.split(','),
        cvUploadFileCollection: [],
        stagedCandidate: null,
        stagedCandidateForm: null,
        stagedCandidateDuplicates: null,
        stagedCandidateDiff: null,
        sendCandidateFlag: false
    },
    mutations: {
        setSendCandidateFlag(state, val){
            state.sendCandidateFlag = val;
        },
        setCvUploadFileCollection(state, files){
            state.cvUploadFileCollection = files;
        },
        setStagedCandidate(state, candidate){
            state.stagedCandidate = candidate;
        },
        setStagedCandidateForm(state, candidate){
            state.stagedCandidateForm = candidate;
        },
        setStagedCandidateFormField(state, {field, value}){
           
            state.stagedCandidateForm.fields[field].value = value;
        },
        setStagedCandidateDuplicates(state, duplicates){
            state.stagedCandidateDuplicates = duplicates;
        },
        setStagedCandidateDiffs(state, diff){
            state.stagedCandidateDiff = diff;
        },
        selectStagedCandidateDiff(state, {name, src}){
            let newDiffState = Object.assign({}, state.stagedCandidateDiff);
            newDiffState[name].selected = src;
            state.stagedCandidateDiff = newDiffState;
        },
        selectStagedCandidateDiffAll(state, src){
            let newDiffState = Object.assign({}, state.stagedCandidateDiff);
            for (let diff in newDiffState) {
                if (newDiffState.hasOwnProperty(diff)) {
                    newDiffState[diff].selected = src;
                }
            }
            state.stagedCandidateDiff = newDiffState;
        },
        swapStagedCandidate(state, candidate) {
            //Updates Staged Candidate to match the parsed candidate
            let newStagedCandidateForm = new StagedCandidateModel(candidate);
            for (let field in state.stagedCandidateForm.fields){
                let x = Object.assign({}, state.stagedCandidateForm.fields[field]);
                newStagedCandidateForm.fields[field].initialValue = x.initialValue;
            }
            state.stagedCandidateForm = newStagedCandidateForm;
            state.stagedCandidate = candidate;
        },
        unlinkExternalId(state) {
          
            state.stagedCandidateForm.fields.forCandidateId.value = '';
            //Reset values from SF to null in stagedCandidate
            
            state.stagedCandidate.externalId = null;
            for (let field in state.stagedCandidate){
                if (state.stagedCandidate[field] && state.stagedCandidate[field].sf) {
                    state.stagedCandidate[field].sf = null;
                    state.stagedCandidateForm.fields[field].initialValue = state.stagedCandidateForm.fields[field].value;
                }
            }

        },
        resetProvince(state) {
            state.stagedCandidateForm.fields.province.value = '';
        }
    },
    actions: {
        toggleSendCandidateFlag({commit, state}){
            commit('setSendCandidateFlag', (!state.sendCandidateFlag));
        },
        addCvFile({commit}, file){

        },
        async fetchStagedCandidate({commit, state}, candidateId) {
            //TODO: Implement fetch state
            return getStagedCandidate(candidateId)
            .then((json) => {
                if(json){
                    commit('setStagedCandidateForm', new StagedCandidateModel(json.stagedCandidate));
                    commit('setStagedCandidate', json.stagedCandidate);
                }
            });
            
        },
        async fetchStagedCandidateDuplicates({commit}, candidate) {
            return getDuplicates(candidate)
            .then((dupes) => {
                commit('setStagedCandidateDuplicates', dupes.candidates);
            });
        },
        async generateStagedCandidateDiffs({commit, state}, candidate){
            // Compares provided staged candidate (retrieved from api) to the current staged candidate form, producing an object containing all the differences between the two.
            if (candidate) {
                commit('setStagedCandidateDiffs', {});
                if (candidate.externalId) {
                    let diffs = {};
                    let ignoreFields = ['id','uploadedAt','brand','cvSource','cvFileName','cvDate','status', 'parsingIssues', 'employmentType','forJobId'];
                    let lookupFields = {'country':'Country', 'salutation':'Salutation', 'language':'Language'};

                    // Unless countries are the same, the province should not be show inside the diff
                    if (state.stagedCandidateForm.fields.country.value !== candidate.country.sf) {
                        ignoreFields.push('province');
                    }

                    for(let field in state.stagedCandidateForm.fields){
                        if (candidate[field] && ignoreFields.indexOf(field) === -1){
                            if (state.stagedCandidateForm.fields[field].value !== candidate[field].sf && (state.stagedCandidateForm.fields[field].value || candidate[field].sf)){
                                diffs[field] = {'sc': state.stagedCandidateForm.fields[field].value, 'sf': candidate[field].sf};
                                if (diffs[field].sc){
                                    diffs[field].selected = 'sc';
                                } else {
                                    diffs[field].selected = 'sf';
                                }
                                if (lookupFields[field]){
                                    diffs[field].lookup = lookupFields[field];
                                }
                            }

                        }
                    }
                    commit('setStagedCandidateDiffs', diffs);
                }
            }
        },
        applyStagedCandidateDiffs({commit, state}){
            for (let field in state.stagedCandidateDiff) {
                let newVal = state.stagedCandidateDiff[field][state.stagedCandidateDiff[field].selected];
                commit('setStagedCandidateFormField', {field: field, value: newVal});
            }

            // reset all values to remove green highlighting after side by side comparision
            for (let field in state.stagedCandidateForm.fields) {
                state.stagedCandidateForm.fields[field].initialValue = state.stagedCandidateForm.fields[field].value;
            }
        }
        
    }
};